/**
 * CARTAL — Official contact channels.
 *
 * SINGLE SOURCE OF TRUTH used by ContactPage, Footer, FaqPage, and any
 * other component that needs to link/display an official CARTAL contact
 * channel. Never inline these values — always import from this module
 * so a future change updates every surface at once.
 *
 * iter333 — approved contact set (owner-provided):
 *   WhatsApp / voice call : 0500230065  (E.164: +966500230065)
 *   Email                 : admin@cartal.sa
 *   Website               : https://cartal.sa
 *   TikTok                : https://cartal.sa/tiktok
 *   Snapchat              : https://snapchat.com/t/knL3BhYR
 *   X (Twitter)           : https://x.com/cartalsa?s=11
 *   Telegram              : @CARTALSA  (link: https://t.me/CARTALSA)
 */
export const CARTAL_CONTACT = Object.freeze({
  // WhatsApp Business — Customer Support (also the direct call number)
  whatsappNumber: "0500230065",
  whatsappNumberIntl: "966500230065",
  whatsappUrl: "https://wa.me/966500230065",

  // Direct voice call to the same number
  callNumber: "0500230065",
  callTel: "tel:+966500230065",

  // Primary Email — direct correspondence (support, partnerships, press)
  supportEmail: "admin@cartal.sa",
  supportEmailMailto: "mailto:admin@cartal.sa",
  adminEmail: "admin@cartal.sa",
  adminEmailMailto: "mailto:admin@cartal.sa",

  // Website
  website: "https://cartal.sa",

  // Social media
  tiktokUrl: "https://cartal.sa/tiktok",
  snapchatUrl: "https://snapchat.com/t/knL3BhYR",
  xUrl: "https://x.com/cartalsa?s=11",
  telegramHandle: "@CARTALSA",
  telegramUrl: "https://t.me/CARTALSA",
});

export const CARTAL_LABELS = Object.freeze({
  whatsapp: {
    ar: "واتساب الأعمال – الدعم وخدمة العملاء",
    en: "WhatsApp Business – Customer Support",
  },
  whatsappShort: { ar: "واتساب", en: "WhatsApp" },
  call: { ar: "اتصال مباشر", en: "Direct call" },
  supportEmail: { ar: "البريد الإلكتروني", en: "Email" },
  adminEmail: { ar: "البريد الإداري", en: "Admin / Business Email" },
  website: { ar: "الموقع", en: "Website" },
  tiktok: { ar: "تيك توك", en: "TikTok" },
  snapchat: { ar: "سناب شات", en: "Snapchat" },
  x: { ar: "منصة X", en: "X (Twitter)" },
  telegram: { ar: "تيليجرام", en: "Telegram" },
  // Legacy label kept to avoid import errors on surfaces not yet updated.
  unifiedNumber: { ar: "الرقم الموحد", en: "National Unified Number" },
});
